import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'

const ManagerRoutes = () => {
  const SalesPage = lazy(() => import('../modules/manager/sales/SalesPage'))
  // const PartnersPage = lazy(() => import('../modules/manager/partner/PartnersPage'))
  const InstallmentPackagesPage = lazy(() => import('../modules/manager/installment-package/InstallmentPackagesPage'))
  const OfficesPage = lazy(() => import('../modules/manager/office-management/OfficesPage'))
  const ManageClientPage = lazy(() => import('../modules/manager/manage-client/ManageClientPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/sales' />} />
        {/* Pages */}
        <Route
          path='sales/*'
          element={
            <SuspensedView>
              <SalesPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='partners/*'
          element={
            <SuspensedView>
              <PartnersPage />
            </SuspensedView>
          }
        /> */}
        <Route
          path='manage-client/*'
          element={
            <SuspensedView>
              <ManageClientPage />
            </SuspensedView>
          }
        />
        <Route
          path='installment-package/*'
          element={
            <SuspensedView>
              <InstallmentPackagesPage />
            </SuspensedView>
          }
        /> 
        <Route
          path='office-management/*'
          element={
            <SuspensedView>
              <OfficesPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { ManagerRoutes }
